import styled from 'styled-components';

export const WalletPageContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    @media (max-width: 500px) {
        padding-top: 32px;
    }

    background-color: ${({ theme }) => theme?.colors?.theme?.appBg};
`;

export const ContentContainer = styled.div`
    width: 100%;
    max-width: 900px;
    display: flex;
    flex-direction: column;
    gap: 48px;
    padding: 0 12px;
    margin-bottom: 48px;
`;

export const SectionContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 32px;
`;

export const CurrenciesList = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px,1fr));
    gap: 1rem;
`;

export const TabHeader = styled.div<{ $gap: number }>`
    display: flex;
    flex-direction: column;
    gap: ${({ $gap }) => $gap}px;
    width: 100%;
    max-width: 900px;
    align-items: center;
`;